// UpgradePopup.tsx
import React, { useState, useEffect } from 'react';
import './upgrade-popup.scss';
import { FaCrown, FaTimes, FaCheck, FaUnlock, FaRegClock } from 'react-icons/fa';
import { getRemainingCases } from '../../utils/caseTracker';

interface UpgradePopupProps {
  onUpgrade: () => void;
  onClose: () => void;
  isExpired?: boolean;
}

export function UpgradePopup({ onUpgrade, onClose, isExpired = false }: UpgradePopupProps) {
  const [remainingCases, setRemainingCases] = useState<number | null>(null);
  
  useEffect(() => {
    // Only fetch remaining cases if not expired
    if (!isExpired) {
      const fetchRemainingCases = async () => {
        try {
          const count = await getRemainingCases();
          setRemainingCases(count);
        } catch (error) {
          console.error('Error fetching remaining cases:', error);
          setRemainingCases(0);
        }
      };
      fetchRemainingCases();
    }
  }, [isExpired]);

  return (
    <div className="upgrade-popup-overlay">
      <div className="upgrade-popup">
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="popup-header">
          <FaCrown className="crown-icon" />
          <h2>{isExpired ? 'Subscription Expired' : 'Continue Practicing?'}</h2>
          {!isExpired && (
            <p className="limit-message">
              {remainingCases === null ? "Loading..." : 
                remainingCases === 0 
                  ? "Daily limit reached" 
                  : `${remainingCases} free case${remainingCases === 1 ? '' : 's'} left`}
            </p>
          )}
          {isExpired && (
            <p className="expired-message">
              Your subscription has expired. Renew now to continue accessing all cases.
            </p>
          )}
        </div>

        <div className="value-stack">
          <div className="benefit-item">
            <FaCheck />
            <span>Full access to 250+ scenarios</span>
          </div>
          <div className="benefit-item">
            <FaUnlock />
            <span>Unlimited practice sessions</span>
          </div>
          <div className="benefit-item">
            <FaRegClock />
            <span>24/7 availability</span>
          </div>
        </div>

        <div className="pricing-cta">
          <div className="price-display">
            £ 10<span>/mo</span>
          </div>
          <p className="price-subtext">just ₦20k (for 30 days 💪)</p>
        </div>

        <button className="upgrade-button" onClick={onUpgrade}>
          <FaCrown /> {isExpired ? 'Renew Subscription' : 'Get Full Access Now'}
        </button>

        <p className="guarantee">
          Loved by top PLAB2 candidates
        </p>
      </div>
    </div>
  );
}